
import enMessages from '../locales/id_ID';

const IdLang = {
    messages: {
        ...enMessages
    },
    locale: 'id-ID',

};
export default IdLang;